.continuity-planning-step{display:flex;flex-direction:column;gap:24px;max-width:720px}.continuity-planning-intro{font-size:14px;color:#707070;margin:0}.continuity-planning-reminder{font-size:14px;font-weight:600;color:#1a1a1a;margin:0}
/*# sourceMappingURL=continuity-planning-step.component-GFE5BDND.css.map */
